import axios from "axios";
import config from "../../../static/config.json";
import router from "../../router/router";
import { Toast } from "vant";

// 微信分享
const state = {};
const mutations = {};
const getters = {};
const actions = {
  //产品详情(展商秀2.0)
  LinkProduct({ rootState }, id) {
    router.push({
      path: `/product-detail?id=${id}`,
    });
  },
  LinkHotProduct({ rootState }, opt) {
    router.push({
      path: `/product-detail?id=${opt.id}&&hotId=${opt.hotId}`,
    });
  },
  // 活动链接(展商秀2.0)
  LinkAct({ rootState }, opt) {
    // opt.acvitityType === 'EXTERNAL_LINK'
    if (opt.externalLink) {
      // 外链
      location.href = opt.externalLink;
    } else {
      if (opt.hasLive && opt.liveAuditState === "PASS") {
        // 直播 (有直播并且审核通过)
        router.push(`/live?actId=${opt.id}`);
      } else {
        // (普通活动)
        router.push(`/nolive?actId=${opt.id}`);
      }
    }
  },
  // 活动链接(展商秀2.0)(活动内的更多活动跳转)
  LinkAct2({ rootState }, opt) {
    if (opt.acvitityType === "EXTERNAL_LINK") {
      // 外链
      location.href = opt.externalLink;
    } else {
      if (opt.hasLive && opt.liveAuditState === "PASS") {
        // 直播 (有直播并且审核通过)
        location.href = location.origin + `/live?actId=${opt.id}`;
      } else {
        // (普通活动)
        location.href = location.origin + `/nolive?actId=${opt.id}`;
      }
    }
  },
  LinkHotPub({ rootState }, opt) {
    // 发布话题(展商秀2.0)
    if (opt.id) {
      router.push(`/hotPub?topicId=${opt.id}`);
    } else if (opt.talkId) {
      router.push(`/hotPub?talkId=${opt.talkId}&isEdit=true`);
    } else {
      router.push(`/hotPub`);
    }
  },

  LinkProduct2({ rootState }, id) {
    location.href = location.origin + `/shopDetails?productId=${id}`;
  },
  // LinkHotProduct({rootState},opt){
  //   router.push({ path: `/shopDetails?productId=${opt.id}&hotId=${opt.hotId}` });
  // },
  //专题 展商二级（详情）(专题页)
  async LinkExhibitionDetails({ rootState, dispatch }, id) {
    let result = await dispatch("getExhibitorTj", id);
    if (result) {
      router.push({
        path: `/exhibition-details?exhibitorId=${id}`,
      });
    } else {
      Toast.fail("专题页暂无内容");
    }
  },
  async LinkHotExhibitionDetails({ rootState, dispatch }, opt) {
    let result = await dispatch("getExhibitorTj", opt.id);
    if (result) {
      router.push({
        path: `/exhibition-details?exhibitorId=${opt.id}&hotId=${opt.hotId}`,
      });
    } else {
      Toast.fail("专题页暂无内容");
    }
  },
  //店铺
  LinkCompany({ rootState }, id) {
    router.push({
      path: `/shop?exhibitorId=${id}`,
    });
  },
  //人脉详情
  LinkConnectionDetails({ rootState }, id) {
    router.push({
      path: `/connectionDetails?inMemberId=${id}`,
    });
  },
  //注册  0普通 1专业
  LinkRegistry({ rootState }, isauthShow) {
    router.push({
      path: `/registry?isauthShow=${isauthShow}`,
    });
  },
  //认证专业卖家
  LinkAuerBach({ rootState }) {
    router.push({
      path: `/editAuerbach`,
    });
  },
  //编辑普通用户
  LinkEditPerson({ rootState }) {
    router.push({
      path: `/editPersonData`,
    });
  },
  //底部跳转
  LinkFooter({ rootState }, opt) {
    if (opt.url.indexOf("boothView") !== -1) {
      // 展位视图
      if (rootState.exhibitionConfig.feature.enabledBmm) {
        // 是否开启展位图
        router.push({
          path: `${opt.url}`,
        });
      } else {
        Toast("The function is not open！");
      }
      console.log(rootState.exhibitionConfig.feature.enabledBmm);
    } else {
      router.push({
        path: `${opt.url}`,
      });
    }
    // location.href = location.origin + opt.url;
  },
  //底部跳转主页
  LinkFooterHome({ rootState }, opt) {
    router.push({
      path: `${opt.url}?roomId=${opt.roomId}&exhibitionId=${opt.exOnId}`,
    });
  },
  //展商
  LinkExhibition({ rootState }, opt) {
    router.push({
      path: `/exhibition/${opt.id}?region=${opt.region}`,
    });
  },
  //人脉
  LinkConnecTion({ rootState }, id) {
    router.push({
      path: `/connection?exhibitionId=${id}`,
    });
  },
  //展商秀2.0新增
  //用户评价
  LinkUserEvaluation({ rootState }, id) {
    router.push({
      path: `/user-evaluation?exhibitorId=${id}&isEx=${true}`,
    });
  },
  //展品用户评价
  LinkUserEvaluation_pro({ rootState }, opt, isEx = false) {
    router.push({
      path: `/user-evaluation?productId=${opt.id}&isEx=${isEx}&exhibitorId=${opt.exhibitorId}`,
    });
  },
  //洽谈间
  LinkTalkLobby({ rootState }) {
    router.push({
      path: `/talk-lobby`,
    });
  },
  //展商邀请函
  LinkExInvitation({ rootState }, opt) {
    if (opt.inMemberId) {
      router.push({
        path: `/exhibitor/${opt.exhibitorId}?inMemberId=${opt.inMemberId}`,
      });
    } else {
      router.push({
        path: `/exhibitor/${opt.exhibitorId}`,
      });
    }
    // router.push({path:`/exhibitor/${opt.exhibitorId}`});
  },
  //话题查询
  goSearch({ rootState }, opt) {
    router.push({
      path: `/hotSearch`,
    });
  },
  //展商秀2.0新增end
  getExhibitorTj({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.https.api}/api/v1/product/has-specialtopicpage?exhibitorId=${id}`, rootState.tokenHeaders)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }
        })
        .catch(err => console.log(err));
    });
  },
  LinkToHotDetails({ rootState }, id) {
    router.push({
      path: `/hotDetails?topicId=${id}`,
    });
  },
  LinkToHotTopDetails({ rootState }, id) {
    router.push({
      path: `/hotTopDetails?talkId=${id}`,
    });
  },

  LinkTohotPub({ rootState }, opt) {
    if (opt.topicId) {
      router.replace({
        path: `/hotPub?id=${opt.id}&topicId=${opt.topicId}`,
      });
    } else {
      router.replace({
        path: `/hotPub?id=${opt.id}`,
      });
    }
  },
  LinkToHeadLinesTab({ rootState }, opt) {
    router.push({
      path: `${opt.url}/${rootState.exhibitionId}?actIndex=${opt.actIndex}`,
    });
  },

  //供需
  LinkHotSupply({ rootState }, id = false) {
    if (id) {
      router.push({
        path: `/hotSupply?editId=${id}`,
      });
    } else {
      router.push({
        path: "/hotSupply",
      });
    }
  },

  //展商秀2.0 用户模块
  //我的证件
  LinkToMyPapers({ rootState }) {
    router.push({
      path: `/my-papers/${rootState.exhibitionId}`,
    });
  },
  //我的人脉
  LinkToMyContacts({ rootState, commit }) {
    commit("setMyContactsHead", 0, {
      root: true,
    });
    router.push({
      path: `/my-contacts/${rootState.exhibitionId}`,
    });
  },
  //我的商机
  LinkToMyBusiness({ rootState, commit }) {
    commit("setMyBusinessHead", 0, {
      root: true,
    });
    router.push({
      path: `/my-business/${rootState.exhibitionId}`,
    });
  },
  //我的关注
  LinkToMyCollect({ rootState, commit }) {
    commit("setMyCollectHead", 0, {
      root: true,
    });
    router.push({
      path: `/my-collect/${rootState.exhibitionId}`,
    });
  },
  //我的-话题
  LinkToMyTopic({ rootState, commit }) {
    commit("setMyTopicHead", 0, {
      root: true,
    });
    router.push({
      path: `/my-topic/${rootState.exhibitionId}`,
    });
  },
  //我的-活动
  LinkToMyActivity({ rootState, commit }) {
    commit("setMyActivityHead", 0, {
      root: true,
    });
    router.push({
      path: `/my-activity/${rootState.exhibitionId}`,
    });
  },
  //我的-直播
  LinkToMyLive({ rootState, commit }) {
    commit("setMyLiveHead", 0, {
      root: true,
    });
    router.push({
      path: `/my-live/${rootState.exhibitionId}`,
    });
  },
  // 预约洽谈
  LinkToMyOrder({ rootState, commit }) {
    commit("setMyTopicHead", 0, {
      root: true,
    });
    router.push({
      path: `/my-order/${rootState.exhibitionId}`,
    });
  },
  //我的-足迹
  LinkToMyTrack({ rootState, commit }) {
    commit("setMyTrackHead", "pro", {
      root: true,
    });
    router.push({
      path: `/my-track/${rootState.exhibitionId}`,
    });
  },
  //我的-消息
  LinkToMyMessage({ rootState, commit }) {
    commit("setMyMessageHead", "all", {
      root: true,
    });
    router.push({
      path: `/my-message/${rootState.exhibitionId}`,
    });
  },
  //我的-反馈
  LinkToMyFeedback({ rootState }) {
    router.push({
      path: "/my-feedback",
    });
  },
  //我的-客服
  LinkToMyService({ rootState }) {
    router.push({
      path: `/my-service/${rootState.exhibitionId}`,
    });
  },
  //我的账户
  LinkToMyAccount({ rootState }, navTab = "income") {
    router.push({
      path: `/my-account?navTab=${navTab}`,
    });
  },
  //打招呼
  LinkToSayHello({ rootState }, id) {
    router.push({
      path: `/say-hello?id=${id}`,
    });
  },

  // 注册页面
  async LinkToReg({ rootState, dispatch, commit }, opt) {
    if (opt) {
      // 有来源 保存注册来源的信息
      commit("setRegOrigin", opt, {
        root: true,
      });
    }
    let isRegLink = rootState.exhibitionConfig.visitorReg.regLink;
    if (isRegLink) {
      // 是否有外链注册地址
      location.href = isRegLink;
    } else {
      let res = await dispatch(
        "getCustomForm",
        {
          itemId: rootState.exhibitionId,
          formType: "show.form.visitor.reg.en",
        },
        {
          root: true,
        }
      );
      console.log(res, "sss");
      if (res && res.items && res.items.length) {
        // 是否有自定义表单
        dispatch("linkToCustom");
      } else {
        router.push({
          path: `/visite/${rootState.exhibitionId}`,
        });
      }
    }
  },

  // 个人中心里的 去掉外链
  async LinkToRegUser({ rootState, getters, dispatch, commit }, opt) {
    if (opt) {
      // 有来源 保存注册来源的信息
      commit("setRegOrigin", opt, {
        root: true,
      });
    }

    let res = await dispatch(
      "getCustomForm",
      {
        itemId: rootState.exhibitionId,
        formType: "show.form.visitor.reg.en",
      },
      {
        root: true,
      }
    );
    console.log(res, "sss");
    if (res && res.items && res.items.length) {
      // 是否有自定义表单
      dispatch("linkToCustom");
    } else {
      router.push({
        path: `/visite/${rootState.exhibitionId}`,
      });
    }
  },
  //我的-洽谈记录
  LinkToMyTalks({ rootState, commit }) {
    router.push({
      path: `/my-talks`,
    });
  },
  //我的-洽谈记录-用户
  LinkToMyTalksUser({ rootState, commit }) {
    router.push({
      path: `/my-talks-user`,
    });
  },
  LinkToMyInquiry({ rootState, commit }) {
    router.push({
      path: `/my-inquiry/${rootState.exhibitionId}`,
    });
  },
  linkToCustom({ rootState, getters, dispatch }) {
    router.push({
      path: `/custom-form/${rootState.exhibitionId}`,
    });
  },

  // 展商入驻
  async LinkToExApply({ rootState, getters, dispatch }) {
    let res = await dispatch(
      "getCustomForm",
      {
        id: rootState.exhibitionId,
        type: "form.exhibitor.reg",
      },
      {
        root: true,
      }
    );
    if (res && res.items.length) {
      // 是否有自定义表单
      router.push({
        path: `/formEx/${rootState.exhibitionId}`,
      });
    } else {
      router.push({
        path: `/exApply/${rootState.exhibitionId}`,
      });
    }
  },

  // 展商入驻完成
  linkToExApplyFinish({ rootState, getters, dispatch }) {
    router.push({
      path: `/exApplyFinish`,
    });
  },

  // 编辑个人资料页面
  async LinkToEditUser({ rootState, getters, dispatch }) {
    // let isRegLink = rootState.exhibitionConfig.visitorReg.regLink;
    // if (isRegLink) { // 是否有外链注册地址
    //   location.href = isRegLink;
    // } else {
    //   let res = await dispatch('getCustomForm', {
    //     id: rootState.exhibitionId,
    //     type: 'show.form.visitor.reg'
    //   }, {
    //     root: true
    //   });
    //   console.log(res, 'ressss')
    //   if (res && res.items.length) { // 是否有自定义表单
    //     dispatch('linkToCustom');
    //   } else {
    //     router.push({
    //       path: `/editUser/${rootState.exhibitionId}`
    //     })
    //   }
    // }
    let res = await dispatch(
      "getCustomForm",
      {
        id: rootState.exhibitionId,
        type: "show.form.visitor.reg",
      },
      {
        root: true,
      }
    );
    if (res && res.items.length) {
      // 是否有自定义表单
      dispatch("linkToCustom");
    } else {
      router.push({
        path: `/editUser/${rootState.exhibitionId}`,
      });
    }
  },

  // 注册完成页
  LinkToRegFinsh({ rootState, getters }) {
    router.push({
      path: `/finishReg`,
    });
  },

  // 商机详情页
  LinkToSupply({ rootState, getters }, id) {
    // router.push({
    //   path: `/needDetails/${id}`
    // })
    console.log("商机", "11");
    window.location = `${location.origin}/needDetails/${id}`;
  },
  // 注册页面
  LinkToActReg({ rootState, getters }, id) {
    router.push({
      path: `/actReg/${id}`,
    });
  },
  // 购票
  LinkToActBuy({ rootState, getters }, id) {
    router.push({
      path: `/actBuy/${id}`,
    });
  },
  // 购票
  LinkToActOrder({ rootState, getters }, id) {
    // router.push({path:`/actOrder/${id}`})
    location.href = location.origin + `/actOrder/${id}`;
  },
  // 完成购票
  LinkToActFinish({ rootState, getters }, id) {
    router.push({
      path: `/actFinish/${id}`,
    });
  },
  // 展商登录
  LinkToExLogin({ rootState, getters }, id) {
    router.push({
      path: `/exLogin/${id}`,
    });
  },

  // 资讯详情页
  async LinkToNewsDetails({ rootState, getters, dispatch }, opt) {
    if (opt.item.externalUrl) {
      // 外链
      let body = {
        articleId: opt.item.id,
        userId: opt.user.userId,
        nickName: opt.user.nickName || opt.user.name,
        avatarUrl: opt.user.avatarUrl,
      };
      await dispatch("follower/addNewsView", body, {
        root: true,
      });
      location.href = opt.item.externalUrl;
    } else {
      router.push({
        path: `/newsDetails/${opt.item.id}`,
      });
    }
  },
  // 404
  LinkToError({ rootState, getters }) {
    router.replace({
      path: "/404",
    });
  },

  // 英文版
  // 登录
  LinkToLogin({ rootState, getters, commit }) {
    let route = router.app._route;
    if (!route.meta.redirect) {
      // 是否可以跳转回调的地址
      commit("setRedirectUrl", location.pathname + location.search, {
        root: true,
      });
    }
    router.push({
      path: `/signIn/${rootState.exhibitionId}`,
    });
  },
  // 忘记密码
  LinkToForgotPsw({ rootState, getters }) {
    router.push({
      path: `/resetpassword/${rootState.exhibitionId}`,
    });
  },
  // 绑定邮箱
  LinkToBindEamil({ rootState, getters }, url) {
    router.push({
      path: `/bindEmail/${rootState.exhibitionId}?url=${url}`,
    });
  },
  //洽谈
  // 在线洽谈间-视频聊天室
  LinkVideoTalk({ rootState }, opt) {
    let host = window.location.host;
    let url = `https://${host}/video-talk?msgId=${opt.msgId}&agoraId=${opt.agoraId}&type=${opt.type}`;
    if (opt.isInitiator) {
      url += `&isInitiator=true`;
    }
    console.log(url, "跳转链接");
    window.location.href = url;
    // return
    // router.push({path:url});
  },
  // 在线洽谈间-客服
  LinkChatTalk({ rootState }, opt) {
    router.push({
      path: `/chat-talk?exhibitionId=${rootState.exhibitionId}&exhibitorId=${opt.exhibitorId}&userId=${opt.userId}`,
    });
  },
  // 在线洽谈间-用户
  LinkChatTalkUser({ rootState }, opt) {
    router.push({
      path: `/chat-talk-user?exhibitorId=${opt.exhibitorId}&userId=${opt.userId}`,
    });
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
